var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.94 3.09961C15.13 3.09961 13.51 3.97961 12.5 5.32961C11.49 3.97961 9.87 3.09961 8.06 3.09961C4.99 3.09961 2.5 5.59961 2.5 8.68961C2.5 9.87961 2.69 10.9796 3.02 11.9996C4.6 16.9996 9.47 19.9896 11.88 20.8096C12.22 20.9296 12.78 20.9296 13.12 20.8096C15.53 19.9896 20.4 16.9996 21.98 11.9996C22.31 10.9796 22.5 9.87961 22.5 8.68961C22.5 5.59961 20.01 3.09961 16.94 3.09961Z",
    fill: "#1B2831",
    fillOpacity: 0.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLike);
export default __webpack_public_path__ + "static/media/heartLike.742f47502927b59717ed28acea276531.svg";
export { ForwardRef as ReactComponent };